<template>
  <div class="area-container" v-if="indexMainShow && indexMainShow.buttons && indexMainShow.buttons.length">
    <div  class="item"  @click="btnClick(item)" v-for="(item,index) in indexMainShow.buttons" :key="index">
      <img :src="item.imgUrl" class="icon" />
      <p class="text">{{ item.desc }}</p>
      <div class="overdue" v-if="indexMainShow.overdue === 'Y' && item.bizType === 'REPAY'">已逾期</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex/dist/vuex.common.js'


export default {
  props: {
    creditStatus: {
      type: String,
      default: ''
    },
    passIndexCardInfo: {
      type: Object,
      default: () => ({})
    },
    showPassCard: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      visible: true
    }
  },
  computed: {
    ...mapState('user', {
      quotaInfo: (state) => state.quotaInfo,
      loanList: (state) => state.quotaInfo.loanList || []
    }),
    ...mapState({
      indexMainShow: (state) => state.caseListV2.indexMainShow || {}
    })
  },
  methods: {
    btnClick (item) {
      const { bizType, desc } = item
      this.$sensors.track('home_icon_click', {
        element_content: desc,
        bizType: bizType
      })
      let repay = false
      
      // 提现中
      if (this.loanList?.length && ['LOAN_AUDIT', 'LOANING', 'QUEUE', 'LOAN_WAIT_UP', 'LOAN_WAIT_VIP'].includes(this.loanList[0]?.loanStatus)) {
        repay = true
      }
      // 授信中 授信拒绝 提现拒绝
      if (['CREDIT_REVIEW', 'CREDIT_REFUSED', 'LOAN_REFUSED'].includes(this.creditStatus)) {
        repay = true
      }
      // pass 卡
      if (this.showPassCard === 'Y') {
        repay = true
      }

      if ((repay || this.indexMainShow?.repaying === 'Y') && bizType === 'REPAY') {
        this.handleReplay(item)
        return 
      }

      if (bizType === 'REPAY') {
        this.$message('当前无还款账单，去借一笔吧')
      }

      if (bizType === 'LOAN') {
        if (['CREDIT_REVIEW'].includes(this.creditStatus) && !this.quotaInfo.creditQueue) {
          this.$message('授信审核中，请稍后再试')
          return
        }
        if (this.showPassCard === 'Y' && ['LIMIT_LOCK', 'LIMIT_FROZEN'].includes(this.passIndexCardInfo.limitExpireShowType)) {
          this.$message('请于额度更新后再申请提现')
          return
        }
      }
      this.$router.push('/middle/limit')
    },
    handleReplay (item) {
      this.$router.push({
        path: '/repayment',
        query: { type: 'TMD' }
      })
    }  
  }
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.area-container {
  display: flex;
  width: 670px;
  height: 192px;
  background: #ffffff;
  border-radius: 20px;
  margin: 0px auto 20px ;
  justify-content: space-around;
  align-items: center;
  position: relative;
  .overdue {
    position: absolute;
    height: 36px;
    width: 80px;
    top: -10px;
    text-align: center;
    left: 60px;
    background-color: #ea3826;
    font-size: 20px;
    line-height: 36px;
    color: #fff;
    border-radius: 20px 20px 20px 0;
    pointer-events: none;
    box-sizing: content-box;
  }
  .item {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    gap: 10px;
    .icon {
      width: 96px;
      height: 96px;
    }
    .text {
      font-size: 28px;
      color: #333333;
      font-family: PingFangSC, PingFang SC;
    }
  }
}
</style>